import { api } from './request'

// 订单统计API
const stats = {
  // 获取销售额统计（日/周/月）
  getSalesStatistics: (params) => api.get('/stats/sales', { params }),

  // 获取商品销量排行
  getProductRanking: (params) => api.get('/stats/products/ranking', { params }),

  // 获取用户复购率分析
  getUserRepurchaseRate: (params) => api.get('/stats/users/repurchase', { params }),

  // 获取订单综合统计报表
  getOrderSummary: () => api.get('/stats/summary')
}

export default stats